var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", {
        on: {
          currentGroup: _vm.currentGroupFunc,
          currentStores: _vm.currentStoresFunc,
        },
      }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-5",
              attrs: { cols: "12", align: "center" },
            },
            [
              _vm.storeSearch == false
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 mt-15",
                      attrs: { cols: "12", id: "group_box" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-2",
                          attrs: { cols: "12", id: "group_box_title" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.tsg("createCameraList")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pt-6 pb-6 pl-15 pr-15",
                          attrs: { cols: "12", align: "left" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pb-2",
                              attrs: { cols: "12" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.tsg("addCameraListSelectCamera"))
                              ),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pb-3",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticStyle: { width: "67%" },
                                    attrs: {
                                      items: _vm.searchResult,
                                      loading: _vm.searchLoading,
                                      "search-input": _vm.search,
                                      "append-icon": "",
                                      color: "white",
                                      dark: "",
                                      "hide-no-data": "",
                                      "hide-selected": "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      "item-text": "cameraName",
                                      placeholder: _vm.tsg(
                                        "cameraInputPlaceholder"
                                      ),
                                      "return-object": "",
                                    },
                                    on: {
                                      "update:searchInput": function ($event) {
                                        _vm.search = $event
                                      },
                                      "update:search-input": function ($event) {
                                        _vm.search = $event
                                      },
                                    },
                                    model: {
                                      value: _vm.cameraSearchInputValue,
                                      callback: function ($$v) {
                                        _vm.cameraSearchInputValue = $$v
                                      },
                                      expression: "cameraSearchInputValue",
                                    },
                                  }),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-2 ml-2",
                                      attrs: {
                                        width: "12%",
                                        height: "auto",
                                        id: "blue_btn",
                                        elevation: "0",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addCameraToList(
                                            _vm.cameraSearchInputValue
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.tsg("add")) + " ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-2 ml-2",
                                      attrs: {
                                        width: "18%",
                                        height: "auto",
                                        id: "blue_btn",
                                        elevation: "0",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.storeSearch = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.tsg("searchCamera")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "12", id: "store_list" },
                            },
                            _vm._l(_vm.cameraList, function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0 pl-1 pr-1",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-2 pt-1 pb-1",
                                      attrs: { cols: "12", id: "store_item" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            align: "center",
                                            justify: "space-between",
                                          },
                                        },
                                        [
                                          _vm._v(" " + _vm._s(item.name) + " "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-0 pa-0 mr-5",
                                              attrs: {
                                                width: "auto",
                                                height: "auto",
                                                id: "back_clean_btn",
                                                elevation: "0",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeCamera(item)
                                                },
                                              },
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "ma-0 pa-0",
                                                attrs: {
                                                  "max-height": "1.25rem",
                                                  "max-width": "1.25rem",
                                                  src: require("@/assets/images/close.png"),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 mt-5",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-2 ml-2",
                                      attrs: {
                                        width: "8rem",
                                        height: "auto",
                                        id: "grey_btn",
                                        elevation: "0",
                                      },
                                      on: { click: _vm.goViewScreen },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.t("back")) + " ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-2 ml-2",
                                      attrs: {
                                        width: "8rem",
                                        height: "auto",
                                        id: "blue_btn",
                                        elevation: "0",
                                      },
                                      on: { click: _vm.goCCTVCheckList },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.t("create")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 mt-15",
                      attrs: { cols: "12", id: "group_box" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-2",
                          attrs: { cols: "12", id: "group_box_title" },
                        },
                        [_vm._v(" " + _vm._s(_vm.tsg("searchCamera2")) + " ")]
                      ),
                      _vm.filterOn == false && _vm.tagOn == false
                        ? _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pt-5 pb-5",
                                  attrs: { cols: "11" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 dialog_text",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.t("theConditions")) +
                                          ": "
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-2 ml-3",
                                          attrs: {
                                            width: "auto",
                                            height: "auto",
                                            id: "back_clean_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.filterOn = true
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              staticStyle: { color: "white" },
                                              attrs: { align: "center" },
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "ma-0 pa-0 mr-2",
                                                attrs: {
                                                  "max-height": "1rem",
                                                  "max-width": "1rem",
                                                  src: require("@/assets/images/plus_white.png"),
                                                },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.t("filtering")) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-2 ml-3",
                                          attrs: {
                                            width: "auto",
                                            height: "auto",
                                            id: "back_clean_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.tagOn = true
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              staticStyle: { color: "white" },
                                              attrs: { align: "center" },
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "ma-0 pa-0 mr-2",
                                                attrs: {
                                                  "max-height": "1rem",
                                                  "max-width": "1rem",
                                                  src: require("@/assets/images/plus_white.png"),
                                                },
                                              }),
                                              _vm._v(
                                                " " + _vm._s(_vm.t("tag")) + " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.areaLoading == false
                                    ? [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0 pb-2",
                                            attrs: { justify: "start" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: {
                                                  cols: "12",
                                                  id: "noneBorderBox",
                                                },
                                              },
                                              [
                                                _vm.storeList.length > 0
                                                  ? _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0 pl-1 pr-1",
                                                        attrs: { cols: "12" },
                                                      },
                                                      [
                                                        _c("v-treeview", {
                                                          attrs: {
                                                            "selected-color":
                                                              "blue",
                                                            selectable: "",
                                                            dark: "",
                                                            dense: "",
                                                            "item-disabled":
                                                              "locked",
                                                            items:
                                                              _vm.storeList,
                                                            "return-object": "",
                                                          },
                                                          on: {
                                                            "update:open":
                                                              _vm.treeviewOpenFunc,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "label",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var item =
                                                                    ref.item
                                                                  return [
                                                                    item.lastNode ==
                                                                      true &&
                                                                    item.streamAble
                                                                      ? _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "ma-0 pa-0",
                                                                            attrs:
                                                                              {
                                                                                cols: "auto",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    src: item.thumbnail,
                                                                                    id: "treeview_image",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "auto",
                                                                                    id: "treeview_screen_bar",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      item.name
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : item.lastNode ==
                                                                          true &&
                                                                        !item.streamAble
                                                                      ? _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "ma-0 pa-0",
                                                                            attrs:
                                                                              {
                                                                                cols: "auto",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    src: require("@/assets/images/grey_box.png"),
                                                                                    id: "treeview_image",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "auto",
                                                                                    id: "treeview_screen_bar",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      item.name
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  item.name
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3964240632
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.selection,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.selection =
                                                                $$v
                                                            },
                                                            expression:
                                                              "selection",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-12",
                                                        attrs: { cols: "12" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.t("noData")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0 pb-2",
                                            attrs: { justify: "start" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: {
                                                  cols: "12",
                                                  id: "noneBorderBox",
                                                },
                                              },
                                              [
                                                _c("v-skeleton-loader", {
                                                  attrs: {
                                                    boilerplate: false,
                                                    elevation: "0",
                                                    dark: "",
                                                    type: "list-item-three-line, list-item-two-line, list-item-three-line",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 pt-2 pb-2",
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            width: "8rem",
                                            height: "2rem",
                                            id: "grey_btn",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.storeSearch = false
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.t("back")))]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-0 ml-2",
                                          attrs: {
                                            width: "8rem",
                                            height: "2rem",
                                            id: "blue_btn",
                                          },
                                          on: { click: _vm.addCamerasToList },
                                        },
                                        [_vm._v(_vm._s(_vm.t("add")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.filterOn
                        ? _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pt-5 pb-5",
                                  attrs: { cols: "11" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "ma-0 pa-0 mb-10 dialog_text",
                                      attrs: {
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0 dialog_text",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.t("theConditions")) +
                                              ": "
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-0 pa-2 ml-3",
                                              attrs: {
                                                width: "auto",
                                                height: "auto",
                                                id: "back_clean_btn",
                                                elevation: "0",
                                              },
                                              on: { click: _vm.filterOpenBtn },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  staticStyle: {
                                                    color: "white",
                                                  },
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "ma-0 pa-0 mr-2",
                                                    class: {
                                                      rotate_icon: _vm.filterOn,
                                                    },
                                                    attrs: {
                                                      "max-height": "1rem",
                                                      "max-width": "1rem",
                                                      src: require("@/assets/images/plus_white.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.t("filtering")
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-0 pa-2 ml-3",
                                              attrs: {
                                                width: "auto",
                                                height: "auto",
                                                id: "back_clean_btn",
                                                elevation: "0",
                                              },
                                              on: { click: _vm.tagOpenBtn },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  staticStyle: {
                                                    color: "white",
                                                  },
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "ma-0 pa-0 mr-2",
                                                    class: {
                                                      rotate_icon: _vm.tagOn,
                                                    },
                                                    attrs: {
                                                      "max-height": "1rem",
                                                      "max-width": "1rem",
                                                      src: require("@/assets/images/plus_white.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.t("tag")) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { id: "blue_btn" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.filterOn = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.t("sure")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { id: "grey_btn" },
                                              on: { click: _vm.resetFiltering },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.t("reset")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 pb-2",
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            cols: "12",
                                            id: "filterBox",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                { staticClass: "ma-0 pa-0" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "ma-0 pa-2 pr-4",
                                                      staticStyle: {
                                                        "border-right":
                                                          "3px solid #4A4A4A",
                                                      },
                                                      attrs: {
                                                        cols: "2",
                                                        align: "right",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.t("cctvCamera")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: { cols: "10" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "ma-0 pa-2 pt-0 pl-4",
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0",
                                                              attrs: {
                                                                cols: "4",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0",
                                                                  attrs: {
                                                                    align:
                                                                      "center",
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.motionCheck,
                                                                          expression:
                                                                            "motionCheck",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      id: "check_box",
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm.motionCheck
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm.motionCheck,
                                                                              null
                                                                            ) >
                                                                            -1
                                                                          : _vm.motionCheck,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm.motionCheck,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                null,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                (_vm.motionCheck =
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  ))
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                (_vm.motionCheck =
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                            }
                                                                          } else {
                                                                            _vm.motionCheck =
                                                                              $$c
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0 ml-3",
                                                                      attrs: {
                                                                        cols: "auto",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.t(
                                                                            "motionDetect"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0",
                                                              attrs: {
                                                                cols: "8",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0",
                                                                  attrs: {
                                                                    align:
                                                                      "center",
                                                                    justify:
                                                                      "space-between",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0",
                                                                      attrs: {
                                                                        cols: "5.5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "CustomDatePicker",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              viewTextField: true,
                                                                              initDate: true,
                                                                            },
                                                                          on: {
                                                                            resultDate:
                                                                              _vm.motionDetectBeginDateFunc,
                                                                          },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0 pl-1 pr-1",
                                                                      attrs: {
                                                                        cols: "auto",
                                                                        align:
                                                                          "center",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "~"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0",
                                                                      attrs: {
                                                                        cols: "5.5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "CustomDatePicker",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              viewTextField: true,
                                                                            },
                                                                          on: {
                                                                            resultDate:
                                                                              _vm.motionDetectEndingDateFunc,
                                                                          },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "ma-0 pa-2 pt-0 pl-4",
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0",
                                                              attrs: {
                                                                cols: "4",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0",
                                                                  attrs: {
                                                                    align:
                                                                      "center",
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.soundCheck,
                                                                          expression:
                                                                            "soundCheck",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      id: "check_box",
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm.soundCheck
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm.soundCheck,
                                                                              null
                                                                            ) >
                                                                            -1
                                                                          : _vm.soundCheck,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm.soundCheck,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                null,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                (_vm.soundCheck =
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  ))
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                (_vm.soundCheck =
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                            }
                                                                          } else {
                                                                            _vm.soundCheck =
                                                                              $$c
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0 ml-3",
                                                                      attrs: {
                                                                        cols: "auto",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.t(
                                                                            "soundDetect"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0",
                                                              attrs: {
                                                                cols: "8",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0",
                                                                  attrs: {
                                                                    align:
                                                                      "center",
                                                                    justify:
                                                                      "space-between",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0",
                                                                      attrs: {
                                                                        cols: "5.5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "CustomDatePicker",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              viewTextField: true,
                                                                              initDate: true,
                                                                            },
                                                                          on: {
                                                                            resultDate:
                                                                              _vm.soundDetectBeginDateFunc,
                                                                          },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0 pl-1 pr-1",
                                                                      attrs: {
                                                                        cols: "auto",
                                                                        align:
                                                                          "center",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "~"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0",
                                                                      attrs: {
                                                                        cols: "5.5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "CustomDatePicker",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              viewTextField: true,
                                                                            },
                                                                          on: {
                                                                            resultDate:
                                                                              _vm.soundDetectEndingDateFunc,
                                                                          },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tagOn
                        ? _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pt-5 pb-5",
                                  attrs: { cols: "11", id: "filterBox" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 mb-5 dialog_text",
                                      attrs: {
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0 dialog_text",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.t("theConditions")) +
                                              ": "
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-0 pa-2 ml-3",
                                              attrs: {
                                                width: "auto",
                                                height: "auto",
                                                id: "back_clean_btn",
                                                elevation: "0",
                                              },
                                              on: { click: _vm.filterOpenBtn },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  staticStyle: {
                                                    color: "white",
                                                  },
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "ma-0 pa-0 mr-2",
                                                    class: {
                                                      rotate_icon: _vm.filterOn,
                                                    },
                                                    attrs: {
                                                      "max-height": "1rem",
                                                      "max-width": "1rem",
                                                      src: require("@/assets/images/plus_white.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.t("filtering")
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-0 pa-2 ml-3",
                                              attrs: {
                                                width: "auto",
                                                height: "auto",
                                                id: "back_clean_btn",
                                                elevation: "0",
                                              },
                                              on: { click: _vm.tagOpenBtn },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  staticStyle: {
                                                    color: "white",
                                                  },
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "ma-0 pa-0 mr-2",
                                                    class: {
                                                      rotate_icon: _vm.tagOn,
                                                    },
                                                    attrs: {
                                                      "max-height": "1rem",
                                                      "max-width": "1rem",
                                                      src: require("@/assets/images/plus_white.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.t("tag")) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { id: "blue_btn" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.tagOn = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.t("sure")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { id: "grey_btn" },
                                              on: { click: _vm.resetTag },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.t("reset")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 pb-2",
                                      attrs: { justify: "start" },
                                    },
                                    _vm._l(_vm.tagList, function (item) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: item.label,
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          item.selected
                                            ? [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4",
                                                    staticStyle: {
                                                      "border-radius": "25px",
                                                      "font-size": "0.8rem",
                                                    },
                                                    attrs: {
                                                      width: "auto",
                                                      height: "auto",
                                                      id: "blue_btn",
                                                      elevation: "0",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.tagClick(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.label) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4",
                                                    staticStyle: {
                                                      "border-radius": "25px",
                                                      "font-size": "0.8rem",
                                                    },
                                                    attrs: {
                                                      width: "auto",
                                                      height: "auto",
                                                      id: "grey_btn",
                                                      elevation: "0",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.tagClick(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.label) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }